<template>
  <div class="update_registration">
    <div class="query_wapper">
      <div class="query_item">
        <el-select
          @change="handleSearch"
          style="width:180px"
          placeholder="按注册项目查看"
          :popper-append-to-body="false"
          v-model="query.project"
          clearable
        >
          <el-option
            v-for="(temp,num) in projectList"
            :key="num"
            :value="temp.value"
            :label="temp.label"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          @change="handleSearch"
          style="width:180px"
          placeholder="按职称查看"
          :popper-append-to-body="false"
          v-model="query.professionalRanks"
          clearable
        >
          <el-option
            v-for="(item,index) in professionalRanksList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          @change="handleSearch"
          style="width:180px"
          placeholder="按性别查看"
          :popper-append-to-body="false"
          v-model="query.gender"
          clearable
        >
          <el-option :value="1" label="男"></el-option>
          <el-option :value="0" label="女"></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          style="width:180px"
          @change="handleSearch"
          clearable
          v-model="query.state"
          placeholder="按状态查看"
          :popper-append-to-body="false"
        >
          <el-option :value="5" label="分会通过"></el-option>
          <el-option :value="3" label="分会待审核"></el-option>
          <el-option :value="4" label="分会未通过"></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-select
          style="width:180px"
          @change="handleSearch"
          clearable
          v-model="query.refereeRank"
          placeholder="按等级查看"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="(item,index) in refereeRankList"
            :key="index"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <div class="query_item">
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:290px"
          @keyup.enter.native="handleSearch"
        >
          <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
        </el-input>
      </div>
    </div>
    <p class="title" v-if="cut">裁判员个人制裁情况登记表</p>
    <el-table
      v-if="!cut"
      :data="tableData"
      border
      highlight-current-row
      style="width:100%;margin-top:10px"
    >
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <el-table-column label="姓名" width="100" align="center" prop="name"></el-table-column>
      <el-table-column label="性别" width="60" align="center" prop="genderText"></el-table-column>
      <el-table-column label="民族" width="100" align="center" prop="nation"></el-table-column>
      <el-table-column label="出生年月" width="100" align="center" prop="birthdayText"></el-table-column>
      <el-table-column label="职称" width="100" align="center" prop="professionalRanks"></el-table-column>
      <el-table-column label="注册证号" min-width="150" align="center" prop="registerNumber"></el-table-column>
      <el-table-column label="最后学历" width="100" align="center" prop="education">
        <template slot-scope="{row}">
          <span>{{row.education === 1?'大专':row.education === 2?'本科':row.education === 3?'研究生':row.education === 4?'其他':''}}</span>
        </template>
      </el-table-column>
      <el-table-column label="注册项目" width="100" align="center" prop="projectNewText"></el-table-column>
      <el-table-column label="裁判等级" width="100" align="center" prop="refereeRank"></el-table-column>
      <el-table-column label="批准时间" width="100" align="center" prop="passDate">
        <template slot-scope="{row}">
          <span>{{formatTime(row.passDate)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="移动电话" width="130" align="center" prop="phone"></el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <span
            :style="{color:screenStatus(scope.row.state).color}"
          >{{screenStatus(scope.row.state).label}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="120">
        <template slot-scope="{row}">
          <el-button type="text" size="small" @click="operation(row.id,'watch')">查看</el-button>
          <el-button type="text" size="small" @click="operation(row.id,'update')">修改</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column label="执裁记录" width="100" align="center"></el-table-column> -->
    </el-table>
    <el-table v-else :data="registData" border highlight-current-row style="width:100%;">
      <el-table-column label="序号" width="50" align="center">
        <template slot-scope="{row,$index}">
          <span v-if="$index + 1 === registData.length - 1">{{$index + 1}}</span>
          <span v-else>+</span>
        </template>
      </el-table-column>
      <el-table-column label="姓名" width="160" align="center">
        <template slot-scope="{row,column,$index}">
          <template v-if="$index + 1 <= registData.length - 1">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'name','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectUser($event,$index,'name')"
                style="height:30px"
                v-if="editable[$index].name"
                v-model="row.name"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'name')"
                class="editRemarkInput"
              >
                <el-option
                  :disabled="item.disabled"
                  v-for="item in athleteList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.name"
                ></el-option>
              </el-select>
              <span v-else>{{row.name}}</span>
            </div>
            <span v-else>{{row.name}}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="性别" width="60" align="center" prop="gender"></el-table-column>
      <el-table-column label="工作单位" width="200" align="center" prop="unit"></el-table-column>
      <el-table-column label="执裁项目" min-width="160" align="center">
        <template slot-scope="{row,column,$index}">
          <template v-if="$index + 1 <= registData.length - 1">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'project','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectUser($event,$index,'project')"
                style="height:30px"
                v-if="editable[$index].project"
                v-model="row.project"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'project')"
                class="editRemarkInput"
              >
                <el-option
                  :disabled="item.disabled"
                  v-for="item in athleteList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.project"
                ></el-option>
              </el-select>
              <span v-else>{{row.project}}</span>
            </div>
            <span v-else>{{row.project}}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="裁判等级" min-width="120" align="center" prop="level"></el-table-column>
      <el-table-column label="赛事名称" width="200" align="center">
        <template slot-scope="{row,column,$index}">
          <template v-if="$index + 1 <= registData.length - 1">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'projectName','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectUser($event,$index,'projectName')"
                style="height:30px"
                v-if="editable[$index].projectName"
                v-model="row.projectName"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'projectName')"
                class="editRemarkInput"
              >
                <el-option
                  :disabled="item.disabled"
                  v-for="item in athleteList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.projectName"
                ></el-option>
              </el-select>
              <span v-else>{{row.projectName}}</span>
            </div>
            <span v-else>{{row.projectName}}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="执裁时间" width="200" align="center">
        <template slot-scope="{row,column,$index}">
          <template v-if="$index + 1 <= registData.length - 1">
            <div
              v-if="publishState === 0 || publishState === 2"
              class="table_select_box"
              style="display:flex;align-items:center;justify-content:center;height:30px"
              @click.stop="{{changeNum($index,'date','editRemarkInput')}}"
            >
              <el-select
                @change="$event=>selectUser($event,$index,'date')"
                style="height:30px"
                v-if="editable[$index].date"
                v-model="row.date"
                clearable
                filterable
                size="mini"
                @blur="$event=>handleBlur($event,$index,'date')"
                class="editRemarkInput"
              >
                <el-option
                  :disabled="item.disabled"
                  v-for="item in athleteList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.date"
                ></el-option>
              </el-select>
              <span v-else>{{row.date}}</span>
            </div>
            <span v-else>{{row.date}}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="执裁地点" width="200" align="center">
        <template slot-scope="{row,column,$index}">
          <template v-if="$index + 1 <= registData.length - 1">
            <div
              v-if="publishState === 0 || publishState === 2"
              style="display:flex;align-items:center;justify-content:center;min-height:30px"
              @click.stop="{{changeNum($index,'address','editRemarkInput')}}"
            >
              <el-input
                maxlength="15"
                @keyup.native="$event=>handleKeyUp($event,$index,'address','editRemarkInput')"
                v-if="editable[$index].address"
                v-model.trim="row.address"
                size="mini"
                @blur="$event=>handleBlur($event,$index,'address')"
                class="editRemarkInput"
              ></el-input>
              <span v-else>{{row.address}}</span>
            </div>
            <span v-else>{{row.address}}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="分会评价" width="100" align="center" prop="appraise"></el-table-column>
    </el-table>
    <el-pagination
      style="text-align:center;margin:20px 0 0 0"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      @size-change="$event=>sizeChange($event,this.getList)"
      @current-change="$event=>numberChange($event,this.getList)"
      :current-page.sync="pageNo"
      background
      layout="prev, pager, next,sizes"
      :total="total"
    ></el-pagination>
    <el-dialog
      :lock-scroll="false"
      @close="closeDialog"
      center
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="modals.visible"
      :title="modals.title"
      width="1400px"
    >
      <updateRegistrationPage @clearUpdate="clearUpdate" :updateObj="updateObj"></updateRegistrationPage>
    </el-dialog>
  </div>
</template>
<script>
import { refereeList } from "@/api/judge.js";
import registerData from "@/assets/json/register.json";
import { table, message, page } from "@/common/js/mixins.js";
import updateRegistrationPage from "./component/update-registration-page";
import { method } from "@/utils/utils";
export default {
  mixins: [table, message, page],
  components: {
    updateRegistrationPage
  },
  data() {
    return {
      stateList: [
        {
          label: "草稿",
          value: 0,
          color: "rgb(64, 142, 232)"
        },
        {
          label: "学校待审核",
          value: 1,
          color: "rgb(64, 142, 232)"
        },
        { label: "学校未通过", value: 2, color: "rgb(252, 91, 91)" },
        { label: "分会待审核", value: 3, color: "rgb(64, 142, 232)" },
        { label: "分会未通过", value: 4, color: "rgb(252, 91, 91)" },
        { label: "分会通过", value: 5, color: "rgb(51, 204, 154)" }
      ],
      publishState: 0,
      query: {
        project: null,
        professionalRanks: null,
        gender: null,
        state: null,
        refereeRank: null,
        keyword: ""
      },
      modals: {
        visible: false,
        title: "注册信息修改"
      },
      titles: ["name", "project", "projectName", "date", "address"], // 表格需要手动操作项对应key
      editable: [
        {
          name: false,
          project: false,
          projectName: false,
          date: false,
          address: false
        },
        {
          name: false,
          project: false,
          projectName: false,
          date: false,
          address: false
        }
      ],
      registData: [
        {
          name: "下拉/模糊查询",
          gender: "填充",
          unit: "自动填充",
          project: "下拉选择",
          level: "自动识别",
          projectName: "下拉选择",
          date: "下拉选择",
          address: "输入",
          appraise: "自动读取"
        },
        {
          name: "",
          gender: "",
          unit: "",
          project: "",
          level: "",
          projectName: "",
          date: "",
          address: "",
          appraise: ""
        }
      ],
      updateObj: {
        id: "",
        type: ""
      },
      cut: false // 切换执裁情况登记表
    };
  },
  computed: {
    // 时间戳转换
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    },
    // 状态筛选
    screenStatus() {
      return data => {
        let status = {};
        this.stateList.filter(item => {
          if (data === item.value) status = item;
        });
        return status;
      };
    },
    // 项目列表
    projectList() {
      return registerData.judgeProjectList;
    },
    // 职称列表
    professionalRanksList() {
      return registerData.judgeProfessionalRanks;
    },
    // 等级列表
    refereeRankList() {
      return registerData.judgeRefereeRank;
    }
  },
  methods: {
    // 查看/修改 打开弹窗
    operation(id, type) {
      Object.assign(this.updateObj, {
        id,
        type
      });
      this.modals.title = type === "watch" ? "注册信息查看" : "注册信息修改";
      this.modals.visible = true;
    },
    // 表格输入框离开焦点
    handleBlur(e, index, col) {
      setTimeout(() => {
        if (
          (col == "name" ||
            col == "project" ||
            col == "projectName" ||
            col == "date") &&
          this.registData[index][col] === ""
        ) {
          this.$set(
            this.registData[index],
            col,
            col === "name" ? "下拉/模糊查询" : "下拉选择"
          );
        } else if (col === "address" && !this.registData[index][col]) {
          this.$set(this.registData[index], col, "输入");
        }
        this.editable[index][col] = false;
      }, 200);
    },
    // 表格点击
    changeNum(index, row, className) {
      this.editable.filter(item => {
        for (let temp in item) item[temp] = false;
      });
      this.editable[index][row] = true;
      if (
        this.registData[index][row] === "下拉/模糊查询" ||
        this.registData[index][row] === "下拉选择" ||
        this.registData[index][row] === "输入"
      ) {
        this.$set(this.registData[index], row, "");
      }
      this.$nextTick(() => {
        var editInputList = document.getElementsByClassName(className);
        if (row !== "address") editInputList[0].children[0].children[0].focus();
        else editInputList[0].children[0].focus();
      });
    },
    // 选择裁判员
    selectUser(value, num, col, details = false) {},
    // 生成表格
    makeTable() {},
    // 查看/编辑页面返回
    clearUpdate() {
      Object.assign(this.updateObj, this.$options.data().updateObj);
      this.modals.visible = false;
      this.getList();
    },
    closeDialog() {
      Object.assign(this.updateObj, this.$options.data().updateObj);
    },
    // 查询
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      let { state, refereeRank, gender,professionalRanks } = this.query;
      refereeList({
        ...this.query,
        state:!state?null:state,
        refereeRank:!refereeRank?null:refereeRank,
        gender:!gender && gender !== 0?null:gender,
        professionalRanks:!professionalRanks?null:professionalRanks,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.list;
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.update_registration {
  .query_wapper {
    .query_item {
      margin-right: 10px;
    }
  }
  .title {
    margin: 0 0 20px 0;
    color: #444;
    font-size: 20px;
  }
}
</style>